import React, { Fragment, forwardRef } from 'react'

import { icons } from 'app/constants'
import { ProgressRing, ScrollableDirective, MenuItem } from 'components/Zui'
import './index.css'

const SearchbarContent = ({ isLoading, data, onSelect, dataKeys, classes }, ref) => {
    const cl = ['search-suggestion-wrapper', ...classes].join(' ')
    return (
        <Fragment>
            {isLoading ? (
                <div className={cl} ref={ref}>
                    <div className="search-suggestion-loader">
                        <ProgressRing size="s16"></ProgressRing>
                    </div>
                </div>
            ) : (
                <>
                    {data && data.length > 0 && (
                        <div className={cl} ref={ref}>
                            <ScrollableDirective style={{ maxHeight: '320px' }}>
                                {data.map(sug => {
                                    const ICON = icons[sug.type]
                                    return (
                                        <React.Fragment key={sug.type}>
                                            {sug.data.length > 0 &&
                                                sug.data.map(d => (
                                                    <MenuItem
                                                        value="1"
                                                        size="s"
                                                        onClick={() =>
                                                            onSelect({
                                                                ...d,
                                                                keyword: d.name,
                                                                type: sug.type,
                                                            })
                                                        }
                                                        key={d.id + sug.type}
                                                    >
                                                        {ICON && <ICON slot="icon" />}
                                                        {d.name}
                                                    </MenuItem>
                                                ))}
                                        </React.Fragment>
                                    )
                                })}
                            </ScrollableDirective>
                        </div>
                    )}
                </>
            )}
        </Fragment>
    )
}

export default forwardRef(SearchbarContent)
